module.exports = __webpack_public_path__ + "static/media/dodgem(5).a08d7b50.PNG";